import { BasicMoreSettings } from './BasicMoreSettings'
import { StandardPdfSettings } from 'apps/builder/components/settings/modal/shared'

export const SignatureMoreSettings = entry => {
  return (
    <>
      <StandardPdfSettings {...entry} />
      <BasicMoreSettings
        mobileVisible={false}
        pageBreakAfter={false}
        placeValueIn={false}
        {...entry}
      />
    </>
  )
}
